import { gql } from 'graphql-request'

export const examAttemptFragment = gql`
  fragment examAttempt on ExamAttempt {
    id
    customer {
      id
    }
    correctCount
    incorrectCount
    totalCount
    isPassed
    created_at
    updated_at
  }
`

export const examFragment = gql`
  fragment exam on Exam {
    id
    name
    type
    image
    description
    additionalDescriptionOne
    additionalDescriptionTwo
    content
    passingPercentage
    maxAttempts
    questionOrderType
    showAllRightAnswers
    answerDisplayCount
    displayType
    pivot {
      id
      order_column
    }
    customerAttempts {
      ...examAttempt
    }
  }
  ${examAttemptFragment}
`

// For all attempts done on Exam above, not just current user:
// attempts {
//   ...examAttempt
// }

export const fullSectionFragment = gql`
  fragment fullSection on Section {
    id
    name
    description
    image
    content
    teachersGuideContent
    public
    published
    isHidden
    level {
      id
      name
    }
    schoolYear {
      id
      name
    }
    subject {
      id
      name
      slug
    }
    creator {
      id
    }
    customers {
      id
    }
    subjectAreaTexts {
      id
      text
      orderColumn
      subjectArea {
        id
        name
        orderColumn
      }
    }
    tags {
      id
      name
    }
    exams {
      ...exam
    }
    created_at
    updated_at
  }
  ${examFragment}
`

export const simpleSectionFragment = gql`
  fragment simpleSection on Section {
    id
    name
    description
    image
    teachersGuideContent
    public
    published
    isHidden
    level {
      id
      name
    }
    subject {
      id
      name
      slug
    }
    creator {
      id
    }
    customers {
      id
    }
    subjectAreaTexts {
      id
      text
      orderColumn
      subjectArea {
        id
        name
        orderColumn
      }
    }
    schoolYear {
      id
      name
    }
    tags {
      id
      name
    }
    exams {
      id
      type
    }
  }
`

export const fullBookFragment = gql`
  fragment fullBook on Book {
    id
    name
    description
    image
    public
    published
    isHidden
    level {
      id
      name
    }
    schoolYear {
      id
      name
    }
    subject {
      id
      name
      slug
    }
    subjectAreaTexts {
      id
      text
      orderColumn
      subjectArea {
        id
        name
        orderColumn
      }
    }
    sections {
      id
      name
      description
      image
      content
      teachersGuideContent
      updated_at
      published
      schoolYear {
        id
        name
      }
      subject {
        id
        name
        slug
      }
      level {
        id
        name
      }
      subjectAreaTexts {
        id
        text
        orderColumn
        subjectArea {
          id
          name
          orderColumn
        }
      }
      pivot {
        id
        order_column
      }
    }
    creator {
      id
    }
    customers {
      id
    }
    tags {
      id
      name
    }
    created_at
    updated_at
  }
`

export const simpleBookFragment = gql`
  fragment simpleBook on Book {
    id
    name
    description
    image
    public
    published
    isHidden
    creator {
      id
    }
    customers {
      id
    }
    level {
      id
      name
    }
    schoolYear {
      id
      name
    }
    subject {
      id
      name
      slug
    }
    schoolClasses {
      id
    }
    sections {
      id
      name
      image
      pivot {
        id
        order_column
      }
      exams {
        id
        type
      }
    }
    tags {
      id
      name
    }
  }
`

export const schoolResourceFragment = gql`
  fragment schoolResource on SchoolResource {
    id
    name
    school {
      id
    }
    students {
      id
      first_name
      last_name
      email
      username
      schoolGroups {
        id
        name
        books {
          id
          name
        }
      }
    }
    books {
      id
      name
      image
      public
      published
      isHidden
      creator {
        id
      }
      customers {
        id
      }
      level {
        id
        name
      }
      schoolYear {
        id
        name
      }
      subject {
        id
        name
        slug
      }
      sections {
        id
        name
        image
        exams {
          id
          type
          maxAttempts
          schoolClassAttempts {
            ...examAttempt
          }
        }
      }
      pivot {
        id
        created_at
        sharedBy {
          id
          first_name
          last_name
          image
        }
        is_archived
      }
    }
  }
  ${examAttemptFragment}
`
